import { Routes, Route, Navigate } from "react-router-dom"
import { useAuthContext } from "./hooks/useAuthContext"
import Calculations from "./pages/Manager/Calculations"
//pages
import Dashboard from "./pages/Dashboard"
import Login from "./pages/Login"
import Signup from "./pages/Signup"
import SavedPrices from "./pages/Manager/MyPrices/SavedPrices"
import AdminData from "./pages/Admin/AdminPanel/AdminData"
import PrivateRoutes from "./Routes/PrivateRoutes"
import AdminRoutes from "./Routes/AdminRoutes"
import Knives from "./pages/Manager/Knives"
import UnconfirmedPrices from "./components/Admin/UnconfirmedPrices/UnconfirmedPrices.js"
import UnconfirmedClients from "./components/Admin/UnconfirmedClients/UnconfirmedClients.js"
//auth import
import { auth } from "./firebase/config"
import UnapprovedPrices from "./pages/Manager/MyPrices/UnapprovedPrices"
import LatestUpdates from "./pages/LatestUpdates"
import EditUserProfile from "./components/TopBar/Users/EditUserProfile"
import PriceDetailsPage from "./components/Prices/PriceDetailsPage"
import AllPrices from "./pages/Admin/Prices/AllPrices"
import AllClients from "./pages/Admin/Clients/AllClients"
import DeniedClients from "./pages/Admin/Clients/DeniedClients"
import PaperManagerRoutes from "./Routes/PaperManagerRoutes"
// import PaperManagerMaterials from "./pages/PaperManager/PaperManagerMaterials";
import AdminCalculations from "./pages/Admin/Calculations/AdminCalculations"
import CreateUpdate from "./pages/Admin/Updates/CreateUpdate"
import Users from "./pages/Admin/Users/Users"
import DesignerRoutes from "./Routes/DesignerRoutes"
import UserMaterials from "./pages/Manager/UserMaterials"
import CreateOrder from "./pages/Manager/Orders/CreateOrder"
import AllOrders from "./pages/Manager/Orders/AllOrders"
import Templates from "./pages/Manager/MyPrices/Templates"
import SentBackPrices from "./pages/Manager/MyPrices/SentBackPrices"
import DesignerOrders from "./pages/Designer/Orders/DesignerOrders"
import SentBackOrders from "./pages/Manager/Orders/SentBackOrders"
import ActiveOrderView from "./pages/Designer/Orders/ActiveOrderView"
import OrdersPaperManager from "./pages/PaperManager/Orders/OrdersPaperManager"
import ArsomaPaperManager from "./pages/PaperManager/Machines/Arsoma/ArsomaPaperManager"
import AccountingRoutes from "./Routes/AccountantRoutes"
import OrderMatching from "./pages/Accounting/Invoices/OrderMatching/OrderMatching"
import ArsomaRoutes from "./Routes/ArsomaRoutes"
import VivaRoutes from "./Routes/VivaRoutes"
import ArsomaOrders from "./pages/Arsoma/Orders/ArsomaOrders"
import VivaOrders from "./pages/Viva/Orders/VivaOrders"
import ViewOrderDetails from "./components/Machines/ViewOrderDetails"
import VivaPaperManager from "./pages/PaperManager/Machines/Viva/VivaPaperManager"

import SMaterials from "./pages/SecondWarehouse/SMaterials"
import SRolls from "./pages/SecondWarehouse/SRolls"
import WarehouseMaterials from "./pages/Warehouse/Materials/WarehouseMaterials"
import MaterialSuppliers from "./pages/Warehouse/Materials/MaterialSuppliers"
import Manufacturers from "./pages/Admin/Manufacturers/Manufacturers"
import WarehouseRolls from "./pages/Warehouse/Rolls/WarehouseRolls"
import WarehouseRoutes from "./Routes/WarehouseRoutes"
import WinderRoutes from "./Routes/WinderRoutes"
import WinderOrders from "./pages/Winder/WinderOrders"
import WinderDoneList from "./pages/Winder/WinderDoneList"
import SemiAdmin from "./Routes/SemiAdmin"
import AllInvoices from "./pages/Invoices/AllInvoices"

import RecalculateOrders from "./pages/Admin/Orders/SentBack/RecalculateOrders"
import CreateInvoice from "./pages/Invoices/CreateInvoice"
import ArsomaPlates from "./pages/Designer/Plates/ArsomaPlates"
import VivaPlates from "./pages/Designer/Plates/VivaPlates"
import ClientList from "./pages/Manager/Clients/ClientList"
import CreateClientManager from "./pages/Manager/Clients/Create/CreateClientManager"
import PriceFilters from "./pages/Manager/MyPrices/Filters/PriceFilters"
import TapePrices from "./pages/Manager/MyPrices/TapePrices"
import TapePlates from "./pages/Designer/Plates/TapePlates"
import TapePaperManager from "./pages/PaperManager/Machines/Tape/TapePaperManager"
import TapeRoutes from "./Routes/TapeRoute"
import TapeOders from "./pages/Tape/TapeOders"
import TechnicalRequests from "./pages/Designer/Technical/TechnicalRequests"
import TapeTechnicalRequests from "./pages/Designer/Technical/TapeTechnicalRequests"
import CutterRoutes from "./Routes/CutterRoutes"
import CutterOrders from "./pages/Cutter/Orders/CutterOrders"
import PlateFiles from "./pages/Designer/Files/PlateFiles"
import CutterPaperManager from "./pages/PaperManager/Machines/Cutter/CutterPaperManager"
import PriceRequests from "./pages/Manager/MyPrices/PriceRequests.js"
import RequestTabs from "./pages/Admin/Requests/RequestTabs.js"
import KnivesList from "./pages/Admin/Knives/KnivesList.js"
import VivaPlateList from "./pages/Viva/Orders/VivaPlateList.js"
import UserNotifications from "./pages/Admin/Notifications/UserNotifications.js"
import WinderSequenceTable from "./pages/PaperManager/Machines/Winder/WinderSequenceTable.js"
import HoldOrders from "./pages/Accounting/Orders/HoldOrders.js"
import WarehouseOrders from "./pages/Warehouse/Orders/WarehouseOrders.js"
import PendingOrders from "./pages/Warehouse/Orders/PendingOrders.js"
import AllPackingLists from "./pages/Invoices/AllPackingLists.js"
import AccountingClients from "./pages/Accounting/Clients/AccountingClients.js"
import AccountingInvoices from "./pages/Accounting/Invoices/AccountingInvoices.js"
import AccountingProformas from "./pages/Accounting/Invoices/AccountingProformas.js"
import GetClients from "./pages/Accounting/Clients/GetClients.js"
import SalesReport from "./pages/Admin/Sales/SalesReport.js"
import Report from "./pages/Manager/Report/Report.js"
import InvoiceClientMatching from "./pages/Admin/Sales/InvoiceClientMatching.js"
import AllProformas from "./pages/Invoices/AllProformas.js"
import OrderCustomization from "./pages/Admin/Orders/SentBack/OrderCustomization.js"
import OverduePayments from "./pages/Admin/Sales/OverduePayments.js"
import SalesReportForSales from "./pages/Manager/Report/Report.js"
import RollStoreManagement from "./pages/Warehouse/RollStore/RollStoreManagement.js"
import RollsOrder from "./components/PaperManager/Warehouse/RollStore/RollsOrder.js"
import CurrentRollOrders from "./components/PaperManager/Warehouse/RollStore/CurrentRollOrders.js"
import RollHistory from "./pages/Warehouse/RollStore/RollHistory.js"
import MpOrders from "./pages/Admin/MpOrders/MpOrders.js"
import WinderWaitingList from "./pages/Winder/WinderWaitingList.js"
import Tickets from "./components/Tickets/Tickets.js"
import TicketHoldOrders from "./components/Tickets/TicketHoldOrders.js"
import Salaries from "./pages/Accounting/Salaries/Salaries.js"
import SalaryReCalculator from "./pages/Accounting/Salaries/SalaryReCalculator.js"
import DevSpecRoutes from "./Routes/DevSpecRoutes.js"
import DevSpecOrders from "./pages/DevSpec/DevSpecOrders.js"
import ProductionOrders from "./pages/DevSpec/ProductionOrders.js"
import BankBilances from "./pages/Accounting/Banking/BankBilances.js"
import Leads from "./pages/Manager/Clients/Leads.js"
import Complaints from "./pages/Orders/Complaints.js"
import EmployeeManagment from "./pages/Admin/Employee/EmployeeManagment.js"
import SuppliersList from "./pages/Warehouse/Suppliers/SuppliersList.js"
import ProductTypes from "./pages/Warehouse/Products/ProductTypes.js"
import Warehouse from "./pages/Warehouse/Warehouse/Warehouse.js"
import ReprintRequestsTable from "./pages/Orders/Reprintrequeststable.js"
import SystemOrderCosts from "./pages/Admin/OrderCosts/SystemOrderCosts.js"
import DevSpecCalculations from "./pages/DevSpec/DevSpecCalculations.js"
import NewDisignerOrders from "./pages/Designer/Orders/NewDisignerOrders.js"
import ReminderHistory from "./pages/Admin/Sales/ReminderHistory/ReminderHistory.js"
import OversightPermissions from "./components/Admin/ViewMode/OversightPermissions.jsx"

export default function Router() {
  // auth context
  const {
    user,
    authIsReady,
    admin,
    paperManager,
    designer,
    semiAdmin,
    accountant,
    arsomaUser,
    vivaUser,
    warehouse,
    winder,
    tapeUser,
    cutter,
    devSpecialist,
  } = useAuthContext()

  return (
    <div>
      {authIsReady && (
        <Routes>
          {/* PUBLIC ROUTES */}
          <Route path="/login" element={!user ? <Login /> : <Navigate to="/" />} />
          {/* USER ROUTES */}
          <Route element={<PrivateRoutes user={user} />}>
            <Route exact path="/" element={<Dashboard />} />
            <Route path="/calculations" element={<Calculations />} />
            <Route path="/saved-prices" element={<SavedPrices />} />
            <Route path="/saved-prices/:id" element={<PriceDetailsPage />} />
            <Route path="/unapproved-prices/:id" element={<PriceDetailsPage />} />
            <Route path="/unapproved-prices" element={<UnapprovedPrices />} />
            <Route path="/knives" element={<Knives />} />
            <Route path="/clients/clients-list" element={<ClientList />} />
            <Route path="/all-leads" element={<Leads />} />
            <Route path="/clients/create-client" element={<CreateClientManager />} />
            <Route path="/latest-updates" element={<LatestUpdates />} />
            <Route path="/user-profile" element={<EditUserProfile />} />
            <Route path="/user/user-materials" element={<UserMaterials />} />
            <Route path="/orders/create-order" element={<CreateOrder />} />
            <Route path="/orders/all-orders" element={<AllOrders />} />
            <Route path="/price-templates" element={<Templates />} />
            <Route path="/sent-back-prices" element={<SentBackPrices />} />
            <Route path="/orders/sent-back" element={<SentBackOrders />} />
            <Route path="/invoices/all-invoices" element={<AllInvoices />} />
            <Route path="/invoices/all-proformas" element={<AllProformas />} />
            <Route path="/invoices/all-packing-lists" element={<AllPackingLists />} />
            <Route path="/invoices/create-invoice" element={<CreateInvoice />} />
            <Route path="/price-filters" element={<PriceFilters />} />
            <Route path="/tape-prices" element={<TapePrices />} />
            <Route path="/admin-requests" element={<PriceRequests />} />
            <Route path="/report" element={<Report />} />
            <Route path="/sales-report-overview" element={<SalesReportForSales />} />
            <Route path="/invoices/overdue-payments" element={<OverduePayments />} />
            <Route path="/tickets" element={<Tickets />} />
            <Route path="/complaints" element={<Complaints />} />
          </Route>
          {/* ADMIN ROUTES */}
          <Route element={<AdminRoutes admin={admin} />}>
            <Route
              path="/signup"
              element={
                user && auth.currentUser.email === "reinis@reinis.lv" ? (
                  <Signup />
                ) : (
                  <Navigate to="/" />
                )
              }
            />
            <Route path="/admin-data" element={<AdminData />} />
            <Route path="/admin/materials" element={<WarehouseMaterials />} />
            <Route path="/all-users-edit" element={<Users />} />
            <Route
              path="/create-update"
              element={
                user && auth.currentUser.email === "reinis@reinis.lv" ? (
                  <CreateUpdate />
                ) : (
                  <Dashboard />
                )
              }
            />
            <Route path="/admin/second-warehouse" element={<SMaterials />} />
            <Route path="/admin/second-warehouse-rolls" element={<SRolls />} />
            <Route path="/admin/suppliers" element={<MaterialSuppliers />} />
            <Route path="/admin/orders/sent-back" element={<RecalculateOrders />} />
            <Route path="/admin/denied-list" element={<DeniedClients />} />
            <Route path="/admin/rolls" element={<WarehouseRolls />} />
            <Route path="/admin/requests" element={<RequestTabs />} />
            <Route path="/admin/knives" element={<KnivesList />} />
            <Route path="/admin/notifications" element={<UserNotifications />} />
            <Route path="/accounting/ordered-invoices" element={<OrderMatching />} />
            <Route path="/admin/invoice-client-match" element={<InvoiceClientMatching />} />
            <Route path="/admin/order-customization" element={<OrderCustomization />} />
            <Route path="/admin/roll-management" element={<RollStoreManagement />} />
            <Route path="/admin/roll-history" element={<RollHistory />} />
            <Route path="/admin/mp-orders" element={<MpOrders />} />
            <Route path="/admin/salaries" element={<Salaries />} />
            <Route path="/admin/banking" element={<BankBilances />} />
            <Route path="/order-costs" element={<SystemOrderCosts />} />
            <Route path="/admin/oversight-permissions" element={<OversightPermissions />} />
          </Route>
          {/* ADMIN OR SEMI ADMIN */}
          <Route element={<SemiAdmin semiAdmin={semiAdmin} admin={admin} />}>
            <Route path="/unconfirmed-prices" element={<UnconfirmedPrices />} />
            <Route path="/unconfirmed-clients" element={<UnconfirmedClients />} />
            <Route path="/admin/all-prices" element={<AllPrices />} />
            <Route path="/admin/manufacturers" element={<Manufacturers />} />
            <Route path="/admin/all-prices/:id" element={<PriceDetailsPage />} />
            <Route path="/admin/all-clients" element={<AllClients />} />
            <Route path="/admin/sales-report" element={<SalesReport />} />
            <Route path="/admin/production-orders" element={<ProductionOrders />} />
            <Route path="/unconfirmed-prices/:id" element={<AdminCalculations />} />
            <Route path="admin/accounting-invoices" element={<AccountingInvoices />} />
            <Route path="admin/accounting-proformas" element={<AccountingProformas />} />
            <Route path="/admin/overdue-payments" element={<OverduePayments />} />
            <Route path="/admin/roll-order" element={<RollsOrder />} />
            <Route path="/admin/currenty-roll-orders" element={<CurrentRollOrders />} />
            <Route path="/admin/all-leads" element={<Leads />} />
          </Route>
          {/* PAPER MANAGER */}
          <Route element={<PaperManagerRoutes paperManager={paperManager} />}>
            <Route path="/paper-manager/materials" element={<WarehouseMaterials />} />
            <Route path="/paper-manager/orders" element={<OrdersPaperManager />} />
            <Route path="/paper-manager/arsoma-orders" element={<ArsomaPaperManager />} />
            <Route path="/paper-manager/viva-orders" element={<VivaPaperManager />} />
            <Route path="/paper-manager/rolls" element={<WarehouseRolls />} />
            <Route path="/paper-manager/roll-order" element={<RollsOrder />} />
            <Route path="/paper-manager/tape-orders" element={<TapePaperManager />} />
            <Route path="/paper-manager/cutter-orders" element={<CutterPaperManager />} />
            <Route path="/paper-manager/winder-orders" element={<WinderSequenceTable />} />
            <Route path="/paper-manager/currenty-roll-orders" element={<CurrentRollOrders />} />
            <Route path="/paper-manager/tickets" element={<Tickets />} />
          </Route>
          {/* DESIGNER */}
          <Route element={<DesignerRoutes designer={designer} />}>
            <Route path="/designer/arsoma-plates" element={<ArsomaPlates />} />
            <Route path="/designer/viva-plates" element={<VivaPlates />} />
            <Route path="/designer/order-list" element={<DesignerOrders />} />
            <Route path="/designer/new-order-list" element={<NewDisignerOrders />} />
            <Route path="/designer/order-list/:id" element={<ActiveOrderView />} />
            <Route path="/designer/new-order-list/:id" element={<ActiveOrderView />} />{" "}
            <Route path="/designer/tape-plates" element={<TapePlates />} />
            <Route path="/designer/technical-requests" element={<TechnicalRequests />} />
            <Route path="/designer/tape-technical-requests" element={<TapeTechnicalRequests />} />
            <Route path="/designer/plate-files" element={<PlateFiles />} />
          </Route>

          {/* ACCOUNTANT */}
          <Route element={<AccountingRoutes accountant={accountant} />}>
            <Route path="/accounting/ordered-invoices" element={<OrderMatching />} />
            <Route path="/accounting/clients" element={<AccountingClients />} />
            <Route path="/accounting/get-clients" element={<GetClients />} />
            <Route path="accounting/hold-orders" element={<HoldOrders />} />
            <Route path="accounting/accounting-invoices" element={<AccountingInvoices />} />
            <Route path="accounting/accounting-proformas" element={<AccountingProformas />} />
            <Route path="/accounting/roll-orders" element={<CurrentRollOrders />} />
            <Route path="/accounting/salaries" element={<Salaries />} />
            <Route path="/accounting/salary-re-calculator" element={<SalaryReCalculator />} />
            <Route path="/accounting/banking" element={<BankBilances />} />
          </Route>
          {/* ARSOMA */}
          <Route element={<ArsomaRoutes arsomaUser={arsomaUser} />}>
            <Route path="/arsoma/orders" element={<ArsomaOrders />} />
            <Route path="/arsoma/orders/:id" element={<ViewOrderDetails />} />
            <Route path="/arsoma/arsoma-plates" element={<ArsomaPlates />} />
          </Route>
          {/* VIVA */}
          <Route element={<VivaRoutes vivaUser={vivaUser} />}>
            <Route path="/viva/orders" element={<VivaOrders />} />
            <Route path="/viva/orders/:id" element={<ViewOrderDetails />} />
            <Route path="/viva/plates/" element={<VivaPlateList />} />
          </Route>
          {/* WAREHOUSE */}
          <Route element={<WarehouseRoutes warehouse={warehouse} />}>
            <Route path="/warehouse/materials" element={<WarehouseMaterials />} />
            <Route path="/warehouse/rolls" element={<WarehouseRolls />} />
            <Route path="/warehouse/pending-orders" element={<PendingOrders />} />
            <Route path="/warehouse/warehouse-orders" element={<WarehouseOrders />} />
            <Route path="/warehouse/rolls-store-management" element={<RollStoreManagement />} />
            <Route path="/warehouse/roll-history" element={<RollHistory />} />
          </Route>
          {/* WINDER */}
          <Route element={<WinderRoutes winder={winder} />}>
            <Route path="/winder/orders" element={<WinderOrders />} />
            <Route path="/winder/done-list" element={<WinderDoneList />} />
            <Route path="/winder/waiting-list" element={<WinderWaitingList />} />
            <Route path="/winder/tickets" element={<Tickets />} />
            <Route path="/winder/hold-orders" element={<TicketHoldOrders />} />
          </Route>
          {/* CUTTER */}
          <Route element={<CutterRoutes cutter={cutter} />}>
            <Route exact path="/" element={<Dashboard />} />
            <Route path="/cutter/orders" element={<CutterOrders />} />
          </Route>
          {/* TAPE */}
          <Route element={<TapeRoutes tapeUser={tapeUser} />}>
            <Route path="/tape/orders" element={<TapeOders />} />
          </Route>
          {/* DEV Specialist */}
          <Route element={<DevSpecRoutes devSpecialist={devSpecialist} />}>
            <Route path="/dev-spec/production-orders" element={<ProductionOrders />} />
            <Route path="/dev-spec/orders" element={<DevSpecOrders />} />
            <Route path="/dev-spec/all-invoices" element={<AccountingInvoices />} />
            <Route path="/dev-spec/all-proformas" element={<AccountingProformas />} />
            <Route path="/dev-spec/overdue-payments" element={<OverduePayments />} />
            <Route path="/dev-spec/all-prices/:id" element={<PriceDetailsPage />} />
            <Route path="/dev-spec/all-clients" element={<AllClients />} />
            <Route path="/dev-spec/all-prices" element={<AllPrices />} />
            <Route path="/dev-spec/calculations" element={<Calculations />} />
            <Route path="/dev-spec/sales-report" element={<SalesReport />} />
            <Route path="/dev-spec/machine-settings" element={<AdminData />} />
            <Route path="/dev-spec/suppliers" element={<MaterialSuppliers />} />
            <Route path="/dev-spec/materials" element={<WarehouseMaterials />} />
            <Route path="/dev-spec/requests" element={<RequestTabs />} />
            <Route path="/dev-spec/roll-management" element={<RollStoreManagement />} />
            <Route path="/dev-spec/roll-order" element={<RollsOrder />} />
            <Route path="/dev-spec/currenty-roll-orders" element={<CurrentRollOrders />} />
            <Route path="/dev-spec/roll-history" element={<RollHistory />} />
            <Route path="/dev-spec/all-leads" element={<Leads />} />
            <Route path="/dev-spec/rolls" element={<WarehouseRolls />} />
            <Route path="/dev-spec/employee-managment" element={<EmployeeManagment />} />
            <Route path="/dev-spec/supplier-list" element={<SuppliersList />} />
            <Route path="/dev-spec/product-types" element={<ProductTypes />} />
            <Route path="/dev-spec/warehouse" element={<Warehouse />} />
            <Route path="/dev-spec/reprints" element={<ReprintRequestsTable />} />
            <Route path="/dev-spec/banking" element={<BankBilances />} />
            <Route path="/dev-spec/order-costs" element={<SystemOrderCosts />} />
            <Route path="/dev-spec/dev-calculations" element={<DevSpecCalculations />} />
            <Route path="/dev-spec/paper-manager-orders" element={<OrdersPaperManager />} />
            <Route path="/dev-spec/arsoma-orders" element={<ArsomaPaperManager />} />
            <Route path="/dev-spec/viva-orders" element={<VivaPaperManager />} />
            <Route path="/dev-spec/tape-orders" element={<TapePaperManager />} />
            <Route path="/dev-spec/winder-orders" element={<WinderSequenceTable />} />
            <Route path="/reminder-history" element={<ReminderHistory />} />
          </Route>
        </Routes>
      )}
    </div>
  )
}
